export const PROFILE_METRICS: Record<string, string[]> = {
  VSPN: ["sales", "installs", "clean_sales"],
  NBA: ["points", "assists", "rebounds"],
};

export const PROFILE_METRICS_RANK: Record<string, string[]> = {
  VSPN: ["sales_rank", "installs_rank", "clean_sales_rank"],
  NBA: ["points_rank", "assists_rank", "rebounds_rank"],
};
